/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type UseAlertsForRoleAdAlertFragment = {
  __typename?: 'FccAdAlert'
  id: string
  visibleTo: Array<Types.FccOperatorRoleType>
}

export const UseAlertsForRoleAdAlertFragmentDoc = gql`
    fragment UseAlertsForRoleAdAlert on FccAdAlert {
  id
  visibleTo
}
    `
